import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FaqContentSlotCMSModel from '@/visa-application/models/FaqContentSlotCMSModel';

export default class FAQCMSModel implements CMSModel {
  information = '';
  scroll_anchor_name = '';
  primary_title = '';
  action_button_title1 = '';
  action_button_name1 = '';
  redirect_link1 = '';
  action_button_title2 = '';
  action_button_name2 = '';
  redirect_link2 = '';
  action_sub_title = '';
  input_placeholder = '';
  search_content_empty_prompt = '';
  meta_title = '';
  meta_description = '';
  meta_keywords = '';
  hide_faq_content = false;
  rating = false;
  rating_content = '';
  floating_prompt = '';

  map(obj: any): void {
    this.information = _.get(obj, 'translation[0].information', '');
    this.scroll_anchor_name = _.get(obj, 'translation[0].scroll_anchor_name', '');
    this.primary_title = _.get(obj, 'translation[0].primary_title', '');
    this.action_button_title1 = _.get(obj, 'translation[0].action_button_title1', '');
    this.action_button_name1 = _.get(obj, 'translation[0].action_button_name1', '');
    this.redirect_link1 = _.get(obj, 'redirect_link1', '');
    this.action_button_title2 = _.get(obj, 'translation[0].action_button_title2', '');
    this.action_button_name2 = _.get(obj, 'translation[0].action_button_name2', '');
    this.redirect_link2 = _.get(obj, 'redirect_link2', '');
    this.action_sub_title = _.get(obj, 'translation[0].action_sub_title', '');
    this.input_placeholder = _.get(obj, 'translation[0].input_placeholder', 'Please enter search content');
    this.search_content_empty_prompt = _.get(obj, 'translation[0].search_content_empty_prompt', '');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
    this.hide_faq_content = _.get(obj, 'hide_faq_content', false);
    this.rating = _.get(obj, 'rating', false);
    this.rating_content = _.get(obj, 'translation[0].rating_content', '');
    this.floating_prompt = _.get(obj, 'translation[0].floating_prompt', '');
  }
}
